import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import {
  IDataContext,
  ElderSearchBoxComponent,
  ElderSearchContextDirective,
  ElderChipListSelectComponent,
} from '@elderbyte/ngx-starter'
import { WorkItem } from '../../work-items/work-item'
import { BehaviorSubject } from 'rxjs'
import { ProcessPlan } from '../../../process/process-plans/process-plan'
import { WorkItemFilter } from '../../work-items/work-item.service'
import { AsyncPipe } from '@angular/common'

@Component({
  selector: 'app-work-item-filter',
  templateUrl: './work-item-filter.component.html',
  styleUrls: ['./work-item-filter.component.scss'],
  imports: [
    ElderSearchBoxComponent,
    ElderSearchContextDirective,
    ElderChipListSelectComponent,
    AsyncPipe,
  ],
})
export class WorkItemFilterComponent {
  @Input()
  data: IDataContext<WorkItem>

  involvedProcessPlans$ = new BehaviorSubject<ProcessPlan[]>([])

  @Input()
  public set involvedProcessPlans(involvedPlans: ProcessPlan[]) {
    if (involvedPlans) {
      this.involvedProcessPlans$.next(involvedPlans)
    }
  }

  public updateProcessPlanFilters(processPlans: ProcessPlan[]) {
    this.data?.filter.updateFilters([WorkItemFilter.processPlans(processPlans)])
  }
}
